import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, Home } from 'lucide-react';

const BookingCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        {/* Cancelled Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 text-center">
          {/* Cancel Icon */}
          <div className="flex justify-center mb-6">
            <div className="bg-orange-100 rounded-full p-6">
              <XCircle size={64} className="text-orange-600" />
            </div>
          </div>

          {/* Cancel Message */}
          <h1 className="font-heading text-3xl md:text-4xl text-navy font-bold mb-4">
            Payment Cancelled
          </h1>
          
          <p className="font-body text-lg text-gray-600 mb-8">
            Your booking was not completed.
            <br />
            No charges have been made to your account.
          </p>

          {/* Info Box */}
          <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-6 mb-8">
            <h2 className="font-heading text-xl text-navy font-semibold mb-3">
              Want to try again?
            </h2>
            <p className="font-body text-gray-700">
              You can go back and complete your booking anytime. Your safari package is still available!
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center justify-center space-x-2 bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-4 rounded-full font-bold transition-all hover:scale-105 shadow-lg"
            >
              <ArrowLeft size={20} />
              <span>Try Again</span>
            </button>
            
            <button
              onClick={() => navigate('/')}
              className="flex items-center justify-center space-x-2 bg-white hover:bg-gray-50 text-gray-700 border-2 border-gray-300 px-8 py-4 rounded-full font-bold transition-all hover:scale-105"
            >
              <Home size={20} />
              <span>Back to Home</span>
            </button>
          </div>

          {/* Contact Info */}
          <div className="mt-8 pt-8 border-t border-gray-200">
            <p className="font-body text-sm text-gray-600 mb-2">
              Need help? Contact us:
            </p>
            <div className="flex flex-col md:flex-row gap-4 justify-center items-center text-sm">
              <a 
                href="https://wa.me/917776828551" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-emerald-600 hover:text-emerald-700 font-semibold"
              >
                💬 WhatsApp: +91 7776828551
              </a>
              <span className="hidden md:inline text-gray-400">|</span>
              <a 
                href="mailto:jmdofficials08@gmail.com" 
                className="text-emerald-600 hover:text-emerald-700 font-semibold"
              >
                ✉️ Email Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingCancelled;
